import { useState, type ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useManageAuth } from '../auth';
import { Icon } from './Icons';

const navigation = [
  { to: '/', icon: 'dashboard', label: 'Dashboard', end: true },
  { to: '/customers', icon: 'building', label: 'Customers' },
  { to: '/interest', icon: 'interest', label: 'Interest' },
  { to: '/subscriptions', icon: 'card', label: 'Subscriptions' },
  { to: '/team', icon: 'users', label: 'Team' },
  { to: '/audit', icon: 'audit', label: 'Audit Log' },
];

export function Shell({ children }: { children: ReactNode }) {
  const { user, membership, signOut } = useManageAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const current = navigation.find(item => item.end ? location.pathname === item.to : location.pathname.startsWith(item.to));
  const initial = user?.displayName?.slice(0, 1) || user?.email?.slice(0, 1) || 'M';
  return <div className="app-shell">
    <aside className={`sidebar ${menuOpen ? 'open' : ''}`}>
      <div className="brand-lockup"><img src="/compass-mark.png" alt="" /><div><strong>COMPASS</strong><span>MANAGE</span></div><button className="mobile-close" onClick={() => setMenuOpen(false)} aria-label="Close navigation"><Icon name="close" /></button></div>
      <nav aria-label="Primary navigation">{navigation.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><Icon name={item.icon} /><span>{item.label}</span></NavLink>)}</nav>
      <div className="sidebar-note"><Icon name="shield" /><div><strong>Product administration</strong><span>Secure · Audited</span></div></div>
    </aside>
    {menuOpen && <button className="sidebar-scrim" aria-label="Close navigation" onClick={() => setMenuOpen(false)} />}
    <main className="main-area"><header className="topbar"><button className="mobile-menu" onClick={() => setMenuOpen(true)} aria-label="Open navigation"><Icon name="menu" /></button><div className="topbar-context"><span>Compass Manage</span><strong>{current?.label ?? 'Customer workspace'}</strong></div><div className="topbar-user"><span className="avatar">{initial}</span><div><strong>{user?.displayName || user?.email?.split('@')[0] || 'Product member'}</strong><span>{membership?.role || 'Member'}</span></div><button onClick={() => void signOut()}>Sign out</button></div></header><div className="page-container">{children}</div></main>
  </div>;
}
